import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Avatar } from "@/components/ContactRow";
import { api } from "@/lib/api";
import { abs } from "@/lib/dbc";

export function ProfileAvatar({ name, size }) {
  const { data } = useQuery({ queryKey: ["dbc"], queryFn: () => api.get("/dbc/me"), retry: false, refetchOnMount: "always", refetchOnWindowFocus: true });
  const [failed, setFailed] = useState(null);
  const src = data?.card?.hasPhoto ? abs(data.card.photoUrl) : null;
  if (!src || failed === src) return <Avatar name={name} size={size} />;
  return <img src={src} alt={name || "Profile"} onError={() => setFailed(src)} className="rounded-full object-cover shrink-0" style={{ width: size, height: size }} data-testid="profile-avatar-photo" />;
}
